export default __webpack_public_path__ + "static/media/down-arrow.b270639b.svg";